import { render, staticRenderFns } from "./MallOrder.vue?vue&type=template&id=3cae1e8b&scoped=true&"
import script from "./MallOrder.vue?vue&type=script&lang=js&"
export * from "./MallOrder.vue?vue&type=script&lang=js&"
import style0 from "./MallOrder.vue?vue&type=style&index=0&id=3cae1e8b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cae1e8b",
  null
  
)

export default component.exports